// extracted by mini-css-extract-plugin
export default {"centeredMain":"ApplicationProcessStep_centeredMain__2nNRc"};